import { ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import { BOOKS } from "@/data";

export default function Books() {
  return (
    <section id="books" data-testid="books-section" className="bg-[var(--alt)] py-24 md:py-36">
      <div className="section-pad">
        <div className="max-w-2xl mb-14">
          <Overline>Writings</Overline>
          <Reveal>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05] mt-6">
              Stories from a storyteller of the soul.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="font-sans-ui text-[var(--muted-ink)] text-base md:text-lg leading-relaxed font-light mt-6">
              Beyond the practice, Shubham is the author of two published novels &mdash; tender, reflective explorations of the human heart.
            </p>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 gap-8">
          {BOOKS.map((b, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <a
                href={b.href}
                target="_blank"
                rel="noreferrer"
                data-testid={`book-card-${i}`}
                className="group grid grid-cols-[auto_1fr] gap-7 items-stretch bg-[var(--panel)] border border-[rgba(200,149,54,0.3)] p-6 md:p-7 hover:border-[var(--gold)] transition-colors duration-500"
              >
                {/* Book cover */}
                <div className="relative w-28 md:w-36 aspect-[2/3] overflow-hidden shadow-[0_18px_40px_-20px_rgba(26,20,11,0.7)] ring-1 ring-[rgba(200,149,54,0.3)]">
                  <img
                    src={b.cover}
                    alt={`${b.title} book cover`}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>

                {/* Details */}
                <div className="flex flex-col justify-center">
                  <span className="overline text-[0.55rem] mb-3">Novel</span>
                  <h3 className="font-serif-display text-2xl md:text-3xl leading-tight">{b.title}</h3>
                  <p className="font-sans-ui text-xs tracking-wide text-[var(--gold)] mt-2">{b.subtitle}</p>
                  <p className="font-sans-ui text-sm text-[var(--muted-ink)] leading-relaxed font-light mt-4">{b.note}</p>
                  <span className="inline-flex items-center gap-1.5 font-sans-ui text-sm text-[var(--ink)] mt-6 group-hover:text-[var(--gold)] transition-colors">
                    Read on {b.store}
                    <ArrowUpRight size={15} className="group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-transform duration-300" />
                  </span>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
